
import {nowDateFn} from "@/utils/globalFunction";
import {mapActions} from "vuex";

export default {
  name: "upVersionAlert",
  props:['policyInfo'],
  data(){
    return{
        termsUp:false,
        privacyUp:false,
        context:''
    }
  },
  methods:{
    ...mapActions(['setShowAboutUpVersion']),
    agreeFn(type){
      if(type){
        localStorage.setItem('policyInfoVersionAgree',this.policyInfo.version)
        localStorage.setItem('policyInfoVersionDisagree',this.policyInfo.version)
        localStorage.setItem('policyInfoTime',nowDateFn())
      }else {
        localStorage.setItem('policyInfoVersionDisagree',this.policyInfo.version)
        localStorage.setItem('policyInfoTime',nowDateFn())
      }
      this.setShowAboutUpVersion(false)
    }
  },
    mounted(){
        this.context=this.policyInfo.context
        this.policyInfo.option.forEach((item)=>{
            if(item.id===1){
                this.termsUp=true
            }else if(item.id===2){
                this.privacyUp=true
            }
        })
    }
}
